export type GebeurtenisImageVariant = 'MEDIUM' | 'LARGE' | 'ORIGINAL';

export type GesprekImageVariant = 'SMALL' | 'ORIGINAL';

export type ImageVariant = 'MEDIUM' | 'LARGE' | 'SMALL' | 'ORIGINAL';
